import React from "react";
import { Link } from "react-router-dom";
import { Sparkle } from "@phosphor-icons/react";

export default function ComingSoon({ title = "Hamarosan", subtitle = "Ez a modul a következő fázisban érkezik." }) {
  return (
    <div className="min-h-screen flex items-center justify-center p-8">
      <div className="max-w-md text-center">
        <div className="inline-flex w-12 h-12 rounded-xl bg-[#5e50f7]/10 border border-[#5e50f7]/30 items-center justify-center mb-5">
          <Sparkle size={22} color="#5e50f7" weight="fill" />
        </div>
        <div className="mex-eyebrow mb-2" style={{ color: "#5e50f7" }}>Hamarosan</div>
        <h1 className="font-heading text-3xl mb-3 tracking-tight">{title}</h1>
        <p className="text-[#a1a1a1] text-[14px] mb-6 leading-relaxed">{subtitle}</p>
        <Link
          to="/dashboard"
          className="inline-block px-5 py-2.5 rounded-lg text-[13px] font-medium bg-white/[0.04] border border-white/10 hover:bg-white/[0.08] transition"
          data-testid="coming-soon-back"
        >
          Vissza a vezérlőpultra
        </Link>
      </div>
    </div>
  );
}
